import React, { useEffect } from "react";
import styled from "styled-components";
import theme from "../../styles/theme";
import { useInventoryContext } from "../../contexts/inventory";
import Voucher from "./Voucher";

const Container = styled.div`
  font-family: "Montserrat", sans-serif;
  border-radius: 4px;
  margin: 24px auto;
`;

const BlockTitle = styled.div`
  font-size: 24px;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  border-bottom: 3px solid ${theme.colors.darkLight};
  margin-bottom: 20px;
  padding-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const VouchersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const Inventory = () => {
  const { discounts, loadProfileItems } = useInventoryContext();

  useEffect(() => {
    loadProfileItems();
  }, [loadProfileItems]);

  console.log("Inventory discounts:", discounts);

  if (!discounts) {
    return <div>Loading...</div>;
  }

  return (
    <Container>
      <BlockTitle>Мої ваучери</BlockTitle>
      <VouchersContainer>
        {discounts.map((item) => (
          <Voucher key={item.id} {...item} />
        ))}
      </VouchersContainer>
    </Container>
  );
};

export default Inventory;
